import ConfirmComponent from './confirm.vue'

export default {

    install: Vue => {
        const ConfirmConstructor = Vue.extend( ConfirmComponent )
        const instance = new ConfirmConstructor()
        instance.$mount(document.createElement('div'))
        document.body.appendChild(instance.$el)

        Vue.prototype.$mr_confirm = (message, successHandler, cancelHandler) => {
            instance.message = message
            instance.isShow = true
            if (typeof successHandler !== 'undefined') {
                instance.successHandler = successHandler
            }
            if (typeof cancelHandler !== 'undefined') {
                instance.cancelHandler = cancelHandler
            }
        }
    }

}